import { render, staticRenderFns } from "./azIssue.vue?vue&type=template&id=232bcd90&scoped=true&"
import script from "./azIssue.vue?vue&type=script&lang=js&"
export * from "./azIssue.vue?vue&type=script&lang=js&"
import style0 from "./azIssue.vue?vue&type=style&index=0&id=232bcd90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232bcd90",
  null
  
)

export default component.exports